<template>
  <div class="coupon">
  </div>
</template>

<script>
  export default {
    name: 'DiscountCoupon',
    data() {
      return {
      }
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/DiscountCoupon.vue